import React from "react";
import styles from "./expert-explore.module.css";
import ExpertSpotlight from "../expert-spotlight-2/expert-spotlight";
import ExpertGallery from "../expert-gallery/expert-gallery";
import LogoMarquee from "../logo-marquee/logo-marquee";

const INSTITUTION_LOGOS = [
  { name: "American Physical Therapy Association", src: "/assets/logos/institutions/american_physical_therapy_assc.png" },
  { name: "Baylor College of Medicine", src: "/assets/logos/institutions/baylor_college_of_medicine.png" },
  { name: "Cleveland Clinic", src: "/assets/logos/institutions/cleveland_clinic.png" },
  { name: "Harvard Medical School", src: "/assets/logos/institutions/harvard_med.png" },
  { name: "James Cook University", src: "/assets/logos/institutions/james_cook_univ.jpg" },
  { name: "Katz Institute for Women's Health", src: "/assets/logos/institutions/katz_inst.webp" },
  { name: "Midwestern University", src: "/assets/logos/institutions/midwestern_univ.svg" },
  { name: "Northwell Health", src: "/assets/logos/institutions/northwell_health.svg" },
  { name: "Northwestern Feinberg School of Medicine", src: "/assets/logos/institutions/northwestern_feinberg.jpg" },
  { name: "University of California Irvine", src: "/assets/logos/institutions/uci.png" },
];

export default function ExpertExplore() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.mainHeader}>
          <h2 className={styles.title}>Meet the Experts</h2>
          <p className={styles.subhead}>132 Hand-Selected and Vetted Experts. All Female.</p>
        </div>

        {/* Top Half: Spotlight */}
        <ExpertSpotlight />

      </div>

      {/* Bottom Half: Poster Wall */}
      <ExpertGallery />

      <div className={styles.container}>

        {/* Bridge */}
        <div className={styles.bridgeContainer}>
          <h3 className={styles.bridgeTitle}>A New Level of Diligence</h3>
          <p className={styles.bridgeText}>
            Every expert featured in this book didn't just provide a quote—they <strong>reviewed and approved</strong> the medical findings associated with their expertise. Combined with three years of deep-dive reporting into the <strong>latest peer-reviewed studies</strong>, followed by <strong>independent fact-checking</strong>, this is the most verified resource in women's health today.
          </p>
        </div>

      </div>

      <div className={styles.institutionsContainer}>
        <h3 className={styles.bridgeTitle}>Featuring experts from leading institutions</h3>
        <LogoMarquee
          logos={INSTITUTION_LOGOS}
          variant="stacked"
          logoHeight={36}
          spacing="compact"
        />
      </div>

    </section>
  );
}
